import React, { useState, useEffect, useCallback } from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FadeLoader from "react-spinners/FadeLoader";

//imported
import * as Path from "routes/Path/index";
import AURoadmapsModal from "components/Modals/AURoadmaps";
import { toast } from "react-toastify";
import Table from "components/Table";
import Columns from "./Columns";
import {
  AddFAQ,
  deleteRoadmap,
  editFAQ,
  getRoadmapsList,
  sortRoadmaps,
} from "store/roadmaps/actions";
import { checkPermissions } from "helpers/common";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const List = () => {
  const dispatch = useDispatch();

  const { loading, roadmapsList, totalCount } = useSelector(({ Roadmaps }) => ({
    loading: Roadmaps?.loading,
    roadmapsList: Roadmaps?.roadmapsList,
    totalCount: Roadmaps?.totalCount,
  }));

  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [localRoadmapsList, setLocalRoadmapsList] = useState([]);

  const [formData, setFormData] = useState({
    languageId: "",
    question: "",
    answer: "",
  });
  const [addRoadmapPop, setAddRoadmapPop] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
  });

  const { user } = useSelector((state) => state.Auth);
  const [permissions, setPermissions] = useState({
    add: false,
    edit: false,
    delete: false,
  });

  useEffect(() => {
    if (user?.permissions) {
      setPermissions({
        add: checkPermissions(["add_roadmap"], user?.permissions),
        edit: checkPermissions(["edit_roadmap"], user?.permissions),
        delete: checkPermissions(["delete_roadmap"], user?.permissions),
      });
    }
  }, [user]);

  useEffect(() => {
    getApiData(filter);
  }, [filter]);

  useEffect(() => {
    setcolumns(
      Columns({ deleteHandler, handleEdit, permissions })?.filter((item) => {
        if (
          item?.text === "Action" &&
          !permissions.edit &&
          !permissions.delete
        ) {
          return false;
        }
        return true;
      }),
    );
  }, [permissions, localRoadmapsList]);

  useEffect(() => {
    setLocalRoadmapsList(roadmapsList);
  }, [roadmapsList]);

  async function getApiData() {
    try {
      dispatch(getRoadmapsList({ data: filter }));
    } catch (error) {
      console.error("Error fetching roadmaps:", error);
    }
  }

  const deleteHandler = (id) => {
    try {
      const userConfirmed = window.confirm(
        "Are you sure, you want to delete this roadmap?",
      );
      if (userConfirmed) {
        const callback = (err, res) => {
          if (err) {
          } else {
            getApiData(filter);
          }
        };

        dispatch(
          deleteRoadmap({
            data: { _id: id },
            callback,
          }),
        );
      }
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const handleEdit = (info) => {
    setRowData(info);
    setAddRoadmapPop(true);
  };

  const handleDragEnd = useCallback(
    (result) => {
      if (!result.destination) return;

      // If dropped in the same position, do nothing
      if (result.source.index === result.destination.index) {
        return;
      }

      const items = Array.from(localRoadmapsList);
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);

      // Update local state immediately for better UX
      setLocalRoadmapsList(items);

      // Prepare data for API
      const sortingData = items.map((item, index) => ({
        _id: item._id,
        sortingNumber: index + 1,
      }));

      // Call sorting API
      const callback = (err, res) => {
        if (err) {
          console.error("Sorting error:", err);
          toast.error("Failed to update sorting");
          // Revert to original order on error
          setLocalRoadmapsList(roadmapsList);
        } else {
          toast.success("Sorting updated successfully");
          // Refresh the list to get updated sorted data from backend
          getApiData(filter);
        }
      };

      dispatch(
        sortRoadmaps({
          data: { data: sortingData },
          callback,
        }),
      );
    },
    [dispatch, localRoadmapsList, roadmapsList, filter],
  );

  return (
    <>
      {addRoadmapPop && (
        <AURoadmapsModal
          rowData={rowData}
          show={addRoadmapPop}
          handleClose={() => {
            setRowData(null);
            setAddRoadmapPop(false);
          }}
        />
      )}
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={"Roadmaps"} />

      <section className="section">
        <div className="section-header">
          <h1>{"Roadmaps"}</h1>

          {/* <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">{"Roadmap"} </div>
          </div> */}
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{"Roadmap"}</h2>
                </div>
              </div>
              {permissions.add ? (
                <div className="col-6">
                  <div className="card-header d-flex justify-content-end align-items-center">
                    <button
                      className="btn btn-primary"
                      onClick={() => setAddRoadmapPop(true)}
                    >
                      Add Roadmap
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          {!loading && localRoadmapsList?.length > 0 && (
            <DragDropContext onDragEnd={handleDragEnd}>
              <div className="card">
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-striped table-md">
                      <thead>
                        <tr>
                          <th style={{ width: "50px" }}>#</th>
                          {columns.map((col, idx) => (
                            <th key={idx}>{col.text}</th>
                          ))}
                        </tr>
                      </thead>
                      <Droppable droppableId="roadmaps">
                        {(provided) => (
                          <tbody
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          >
                            {localRoadmapsList.map((item, index) => (
                              <Draggable
                                key={item._id}
                                draggableId={item._id}
                                index={index}
                              >
                                {(provided, snapshot) => (
                                  <tr
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={{
                                      ...provided.draggableProps.style,
                                      background: snapshot.isDragging
                                        ? "#f0f0f0"
                                        : "white",
                                    }}
                                  >
                                    <td>
                                      <i
                                        className="fas fa-grip-vertical"
                                        style={{
                                          cursor: "grab",
                                          color: "#6c757d",
                                        }}
                                      ></i>
                                    </td>
                                    {columns.map((col, colIdx) => (
                                      <td key={colIdx}>
                                        {col.formatter
                                          ? col.formatter(
                                              item[col.dataField],
                                              item,
                                              index,
                                            )
                                          : item[col.dataField]}
                                      </td>
                                    ))}
                                  </tr>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </tbody>
                        )}
                      </Droppable>
                    </table>
                  </div>
                </div>
              </div>
            </DragDropContext>
          )}

          {!loading && localRoadmapsList?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Roadmap Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;
